import React from 'react';
import { withTranslation } from 'react-i18next/hooks';

import {Dialog, DialogActions, DialogContent, DialogTitle} from '@material-ui/core'
import {Container, Box} from '@material-ui/core'
import {Button, FormControl, Checkbox, InputLabel, Select, MenuItem} from '@material-ui/core';
import { getPermissionsArray, getPermissionsFromArray } from '../../../api/helpers';

class EditUserPermissionsDialog_ extends React.Component{

    constructor(props){
        super(props)

        
        let permissions = this.props.permissions

        //console.log('permissions')
        //console.log(permissions)

        let permissionsArr = getPermissionsArray(permissions)

        //console.log('permissionsArr')
        //console.log(permissionsArr)

        this.state = {
            changed: false,
            permissions: permissionsArr,
            errors: {}
        }
    }

    handleSave(){
        if(this.validate()){

            let permissionsArr = this.state.permissions // Array(32)

            let permissions = getPermissionsFromArray(permissionsArr)

            this.props.onAction({type: 'USER_PERMISSIONS_EDITOR_SAVE', permissions: permissions})
        }
    }

    handleClose(){
        if(this.state.changed){
            this.props.onAction({
                type: 'CONFIRM_DIALOG', 
                message: this.props.t('CloseFormConfirm'),
                onConfirm: ()=>{
                    this.props.onAction({type: 'USER_PERMISSIONS_EDITOR_CLOSE'})
                }
            })
        }else{
            this.props.onAction({type: 'USER_PERMISSIONS_EDITOR_CLOSE'})
        }
    }   

    /*
    handleInput(event){
        let changed = {}
        if(!this.state.changed) changed = {changed: true}

        let arr = event.target.name.split('_')
        let i = arr[1]

        let permissions = this.state.permissions
        permissions[i] = event.target.checked?1:0

        this.setState({permissions: permissions, ...changed})
    }
    */


    handleInput(event){
        let changed = {}
        if(!this.state.changed) changed = {changed: true}

        let permissions = this.state.permissions

        console.log('handleInput event.target.name '+ event.target.name)
        switch(event.target.name){
            case 'PresenceMode':
                console.log('set presenceMode = '+event.target.value)
                let flag_11 =  event.target.value & 1
                let flag_12 =  (event.target.value >> 1) & 1
                console.log('flag_11 event.target.value >> 1 ='+ (event.target.value >> 1))
                console.log('flag_12 (event.target.value >> 1) & 1 ='+ ((event.target.value >> 1) & 1))
                console.log('flag_11 = '+flag_11)
                console.log('flag_12 = '+flag_12)
                permissions[11] = flag_11
                permissions[12] = flag_12

            break;

            default:
                let arr = event.target.name.split('_')
                let i = arr[1]
                permissions[i] = event.target.checked
        }

        this.setState({permissions: permissions, ...changed})
    }

    validate(){
        //let errors = this.state.errors;
        let error = false
  /*   
        if(!this.state.group.Name){
            errors.Name = 'Name is empty'
            error = true
        }else{
            errors.Name = false
        }
        this.setState({errors: errors})
*/
        return !error;
    }

    getPresenceMode(){
        //console.log('getPresenceMode')
        //console.log(this.state.permissions)
        //console.log('11:'+this.state.permissions[13])
        //console.log('12:'+this.state.permissions[14])
        let presenceMode = this.state.permissions[11]+this.state.permissions[12]*2
        console.log('get presenceMode = '+presenceMode)
        return presenceMode
    }

    render(){
        const {t} = this.props

        const title = t('UserPermissions')

        const margin = {margin:'16px 0 8px 0'}

        return(
<Dialog
    scroll="body"
    fullWidth={this.props.fullWidth}
    maxWidth={this.props.maxWidth}
    open={this.props.open}
    onClose={this.handleClose.bind(this)}
    aria-labelledby="edit-dialog-title">
        
    <DialogTitle id="edit-dialog-title">{title}</DialogTitle>
    <DialogContent>
        <form>
        <Container maxWidth="lg" style={{minWidth:300}}>
            
            <Box textAlign="" style={{...margin, width: '100%'}}>
                <FormControl>
                    <label>
                        <Checkbox color="primary" 
                            checked={this.state.permissions[1]}
                            onChange={this.handleInput.bind(this)}
                            name="permissions_1"
                            />
                            {t('AllowVoicePTTCalls')}
                    </label>
                </FormControl>
            </Box>

            <Box textAlign="" style={{...margin, width: '100%'}}>
                <FormControl>
                    <label>
                        <Checkbox color="primary" 
                            checked={this.state.permissions[4]}
                            onChange={this.handleInput.bind(this)}
                            name="permissions_4"
                            />
                            {t('AllowVideoPTTCalls')}
                    </label>
                </FormControl>
            </Box>

            <Box textAlign="" style={{...margin, width: '100%'}}>
                <FormControl>
                    <label>
                        <Checkbox color="primary" 
                            checked={this.state.permissions[0]}
                            onChange={this.handleInput.bind(this)}
                            name="permissions_0"
                            />
                            {t('AllowFullDuplexVoiceCalls')}
                    </label>
                </FormControl>
            </Box>

            <Box textAlign="" style={{...margin, width: '100%'}}>
                <FormControl>
                    <label>
                        <Checkbox color="primary" 
                            checked={this.state.permissions[6]}
                            onChange={this.handleInput.bind(this)}
                            name="permissions_6"
                            />
                            {t('AllowMessages')}
                    </label>
                </FormControl>
            </Box>

            <Box textAlign="" style={{...margin, width: '100%'}}>
                <FormControl>
                    <label>
                        <Checkbox color="primary" 
                            checked={this.state.permissions[7]}
                            onChange={this.handleInput.bind(this)}
                            name="permissions_7"
                            />
                            {t('AllowLocationTracking')}
                    </label>
                </FormControl>
            </Box>

            <Box textAlign="" style={{...margin, width: '100%'}}>
                <FormControl>
                    <label>
                        <Checkbox color="primary" 
                            checked={this.state.permissions[8]}
                            onChange={this.handleInput.bind(this)}
                            name="permissions_8"
                            />
                            {t('AllowCallAlert')}
                    </label>
                </FormControl>
            </Box>

            <Box textAlign="" style={{...margin, width: '100%'}}>
                <FormControl>
                    <label>
                        <Checkbox color="primary" 
                            checked={this.state.permissions[17]}
                            onChange={this.handleInput.bind(this)}
                            name="permissions_17"
                            />
                            {t('ShowEventLog')}
                    </label>
                </FormControl>
            </Box>

            <Box textAlign="" style={{...margin, width: '100%'}}>
                <FormControl>
                    <label>
                        <Checkbox color="primary" 
                            checked={this.state.permissions[18]}
                            onChange={this.handleInput.bind(this)}
                            name="permissions_18"
                            />
                            {t('ShowSearchBox')}
                    </label>
                </FormControl>
            </Box>

            <Box textAlign="" style={{...margin, width: '100%'}}>
                <FormControl>
                    <label>
                        <Checkbox color="primary" 
                            checked={this.state.permissions[19]}
                            onChange={this.handleInput.bind(this)}
                            name="permissions_19"
                            />
                            {t('ShowSettings')}
                    </label>
                </FormControl>
            </Box>

            <Box textAlign="" style={{...margin, width: '100%'}}>
                <FormControl>
                    <label>
                        <Checkbox color="primary" 
                            checked={this.state.permissions[20]}
                            onChange={this.handleInput.bind(this)}
                            name="permissions_20"
                            />
                            {t('RestrictPasswordChange')}
                    </label>
                </FormControl>
            </Box>

            
            <Box textAlign="" style={{...margin, width: '100%'}}>
                <FormControl>
                    <label>
                        <Checkbox color="primary" 
                            checked={this.state.permissions[25]}
                            onChange={this.handleInput.bind(this)}
                            name="permissions_25"
                            />
                            {t('RestrictLogoff')}
                    </label>
                </FormControl>
            </Box>

            <Box textAlign="" style={{...margin, width: '100%'}}>
                <FormControl>
                    <label>
                        <Checkbox color="primary" 
                            checked={this.state.permissions[26]}
                            onChange={this.handleInput.bind(this)}
                            name="permissions_26"
                            />
                            {t('RestrictQuit')}
                    </label>
                </FormControl>
            </Box>

            <Box textAlign="" style={{...margin, width: '100%'}}>
                <FormControl>
                    <label>
                        <Checkbox color="primary" 
                            checked={this.state.permissions[36]}
                            onChange={this.handleInput.bind(this)}
                            name="permissions_36"
                            />
                            {t('PhoneCalls')}
                    </label>
                </FormControl>
            </Box>


            <Box textAlign="left">
                <FormControl style={{...margin, width: '100%'}}>
                    <InputLabel htmlFor="PresenceMode(">{t('PresenceMode')}</InputLabel>
                    <Select
                        value={this.getPresenceMode()}
                        onChange={this.handleInput.bind(this)}
                        inputProps={{
                            name: 'PresenceMode',
                            id: 'PresenceMode',
                        }}
                        >
                        <MenuItem key="0" value={0}>{t('AllUsers')}</MenuItem>
                        <MenuItem key="1" value={1}>{t('OnlyGroupMembers')}</MenuItem>
                        <MenuItem key="2" value={2}>{t('OnlyGroups')}</MenuItem>
                        <MenuItem key="3" value={3}>{t('OnlyGroupsAndDispatchers')}</MenuItem>

                    </Select>
                </FormControl>
            </Box>

        </Container>
        </form>
    </DialogContent>
    <DialogActions>
        <Button onClick={this.handleSave.bind(this)} variant="contained" color="primary">
            {t('Apply')}
        </Button>
        <Button onClick={this.handleClose.bind(this)} variant="contained" color="inherit">
            {t('Cancel')}
        </Button>
    </DialogActions>

</Dialog>
        );

    }
}

export const EditUserPermissionsDialog = withTranslation()(EditUserPermissionsDialog_);